<template>

  <div class="mb-lg-5">

    <section class="row" v-if="errorMessages">
      <div class="col-sm-12">
        <ul v-for="message in errorMessages" v-bind:key="message">
          <li>{{message}}</li>
        </ul>
      </div>
    </section>

    <button class="ontario-button ontario-button--secondary sm_home_filter" v-if="screenWidth < 992" v-on:click="filter_expand = !filter_expand">{{ $t("filter_name") }}</button>

    <div class="clearfix"></div>

    <!-- filter -->
    <div v-show="filter_expand" class="filter_show">
      <div class="row d-flex">
        <div class="col-lg-10 h-100 grey_boxes p-4">

           <h3 class="h5">{{ $t("filter_name") }}</h3>

          <fieldset>
            <legend class="d-none">Filter news items</legend>

            <!-- type : note only show for homepage -->
            <div class="dropdown" v-if="routeName == 'home' || routeName == 'ministry' || routeName == 'search'">
              <button class="dropdown-toggle w-100 text-left ontario-input ontario-dropdown" type="button" id="dropdownMenuButton_newstype" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                {{ $t("filter_type") }}
              </button>
              <div class="dropdown-menu w-100 dropdowns_height" @click.stop="" aria-labelledby="dropdownMenuButton_newstype">
                <div class="ontario-form-group" v-for="filter_type in apiData.types" v-bind:key="filter_type.id">
                  <fieldset class="ontario-fieldset">
                      <div class="ontario-checkboxes check_container pr-0 mpb-0 pt-0">
                          <div class="ontario-checkboxes__item" v-if="routeName == 'search'">
                              <input class="ontario-checkboxes__input" v-bind:id="'type_' + filter_type.id" name="filters_types" type="checkbox" v-model="types" :value=filter_type.value :aria-label=filter_type.value>
                              <label class="ontario-checkboxes__label" v-bind:for="'type_' + filter_type.id">
                                  {{ filter_type.label }}
                              </label>
                          </div>
                          <div class="ontario-checkboxes__item check_container pr-0 pb-0 pt-0" v-else>
                              <input class="ontario-checkboxes__input" v-bind:id="'type_' + filter_type.id" name="filters_types" type="checkbox" v-model="types" :value=filter_type.id :aria-label=filter_type.value>
                              <label class="ontario-checkboxes__label" v-bind:for="'type_' + filter_type.id">
                                  {{ filter_type.label }}
                              </label>
                          </div>
                      </div>
                  </fieldset>
                </div>
              </div><!--type-->
            </div>

            <div class="dropdown" v-if="routeName != 'ministry'">
              <button class="dropdown-toggle w-100 ontario-input ontario-dropdown text-left" type="button" id="dropdownMenuButton_ministry" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                {{ $t("filter_ministry") }}
              </button>
              <div class="dropdown-menu w-100 dropdowns_height" @click.stop="" aria-labelledby="dropdownMenuButton_ministry">
                <div class="ontario-form-group" v-for="filter_ministry in apiData.ministries" v-bind:key="filter_ministry.id">
                  <fieldset class="ontario-fieldset">
                      <div class="ontario-checkboxes check_container pr-0 pb-0 pt-0">
                          <div class="ontario-checkboxes__item" v-if="routeName == 'search'">
                              <input class="ontario-checkboxes__input" v-bind:id="'ministry_' + filter_ministry.id" name="filters_ministries" type="checkbox"  v-model="ministries" :value=filter_ministry.name :aria-label=filter_ministry.name_abbreviated>
                              <label class="ontario-checkboxes__label" v-bind:for="'ministry_' + filter_ministry.id">
                                  {{ filter_ministry.name_abbreviated }}
                              </label>
                          </div>
                          <div class="ontario-checkboxes__item" v-else>
                              <input class="ontario-checkboxes__input" v-bind:id="'ministry_' + filter_ministry.id" name="filters_ministries" type="checkbox"  v-model="ministries" :value=filter_ministry.id :aria-label=filter_ministry.name_abbreviated>
                              <label class="ontario-checkboxes__label" v-bind:for="'ministry_' + filter_ministry.id">
                                  {{ filter_ministry.name_abbreviated }}
                              </label>
                          </div>
                      </div>
                  </fieldset>
                </div>
              </div>
            </div><!--ministry-->

            <div class="dropdown">
              <button class="dropdown-toggle w-100 ontario-input ontario-dropdown text-left" type="button" id="dropdownMenuButton_topic" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                {{ $t("filter_topic") }}
              </button>
              <div class="dropdown-menu w-100 dropdowns_height" @click.stop="" aria-labelledby="dropdownMenuButton_topic">
                <div class="ontario-form-group" v-for="filter_topic in apiData.topics" v-bind:key="filter_topic.id">
                  <fieldset class="ontario-fieldset">
                      <div class="ontario-checkboxes check_container pr-0 pb-0 pt-0">
                          <div class="ontario-checkboxes__item" v-if="routeName == 'search'">
                              <input class="ontario-checkboxes__input" v-bind:id="'topic_' + filter_topic.id" name="filters_topics" type="checkbox" v-model="topics" :value=filter_topic.name :aria-label=filter_topic.name>
                              <label class="ontario-checkboxes__label" v-bind:for="'topic_' + filter_topic.id">
                                  {{ filter_topic.name }}
                              </label>
                          </div>
                          <div class="ontario-checkboxes__item" v-else>
                              <input class="ontario-checkboxes__input" v-bind:id="'topic_' + filter_topic.id" name="filters_topics" type="checkbox" v-model="topics" :value=filter_topic.id :aria-label=filter_topic.name>
                              <label class="ontario-checkboxes__label" v-bind:for="'topic_' + filter_topic.id">
                                  {{ filter_topic.name }}
                              </label>
                          </div>
                      </div>
                  </fieldset>
                </div>
              </div>
            </div>
            <!--topic-->

             <div class="dropdown" v-if="routeName == 'search'">
                <button class="dropdown-toggle w-100 ontario-input ontario-dropdown text-left" type="button" id="dropdownMenuButton_date" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                  {{ $t("filter_date") }}
                </button>
                <div class="dropdown-menu w-100 dropdowns_height" aria-labelledby="dropdownMenuButton_date">
                  <div class="p-3">
                      <label for="filter_start_date">{{ $t('filter_start_date') }}</label><br />
                      <input id="filter_start_date" class="ontario-input" type="date" ref="startDate" v-model="start_date" /><br />
                      <label for="filter_end_date">{{ $t('filter_end_date') }}</label><br />
                      <input id="filter_end_date" class="ontario-input" type="date" ref="endDate" v-model="end_date" />
                  </div>
                </div>
              </div>

            <!-- sort -->
            <div class="dropdown sort" v-if="routeName == 'search'">
              <button class="dropdown-toggle w-100 ontario-input ontario-dropdown text-left" type="button" id="dropdownMenuButton_sort" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                {{ $t("filter_sort") }}
              </button>
              <div class="dropdown-menu w-100 ontario-radios p-3" aria-labelledby="dropdownMenuButton_sort">
                <div class="pl-3 pr-0 mb-4 ontario-radios__item">
                  <input id="filter_sort_dsc" class="ontario-input ontario-radios__input" type="radio" ref="filter_sort" v-model="sort" value="desc" />
                  <label class="ontario-label ontario-radios__label" for="filter_sort_dsc">
                    {{ $t("filter_sort_descending") }}
                  </label>
                </div>
                <div class="pl-3 pr-0 mb-4  ontario-radios__item">
                  <input id="filter_sort_asc" class="ontario-input ontario-radios__input" type="radio" ref="filter_sort" v-model="sort" value="asc" />
                  <label class="ontario-label ontario-radios__label" for="filter_sort_asc">
                    {{ $t("filter_sort_ascending") }}
                  </label>
                </div>
              </div>
            </div><!-- sort -->

            <button type="button" id="filter_button" v-on:click="updateFilters"  class="mb-1 ontario-button--primary ontario-button w-100 mt-0">{{ $t("filter_filter") }}</button>
            <button type="button" id="clear_filter_button" v-on:click="clearFilters" class="mb-0 ontario-button--tertiary ontario-button w-100 mt-0">{{ $t("filter_clear") }}</button>
          </fieldset>
        </div><!-- row d-flex -->
      </div><!-- col-lg-9 h-100 p-2 -->
    </div><!-- filter -->

  </div>

</template>

<script>
export default {
  props: ['apiEndPoints', 'routeName'],
  data () {
    return {
      apiData: {},
      types: [],
      ministries: [],
      topics: [],
      start_date: null,
      end_date: null,
      sort: 'desc',
      filter_expand: true,
      selected: [],
      errorMessages: [],
      displayRss: true,
      screenWidth: window.innerWidth,
      gaFilterEventData: {
        type: [],
        ministry: [],
        topic: [],
        publishStartDate: null,
        publishEndDate: null,
        sort: null
      }
    }
  },
  watch: {
    // Watch the apiData object. When it's finished populating, run update filters.
    // If not watched, timing problems occur with the data being ready to compare against in buildSelectedDataObject()
    apiData: function (val) {
      if (Object.keys(this.apiData).length == this.apiEndPoints.length) {
        this.updateFilters()
      }
    }
  },
  methods: {
    // Fetch filter data from the correct endpoints (passed as prop from parent Results)
    fetchFilterData (endPoints) {
      for (let i = 0; i < endPoints.length; i++) {
        this.$axios
          .get(process.env.VUE_APP_ROOT_API + endPoints[i], {
            params: {
              language: this.$root.$i18n.locale
            }
          })
          .then(response => {
            this.$set(this.apiData, [endPoints[i]], response.data.data.flat())
          })
          .catch(error => {
            console.log(error)
            this.errored = true
          })
      }
    },
    // Set data based on incoming query string. For this to work cleanly, the data variables are expected to match the name of the query variables
    // example: ?types=2,3 will match to this.types
    setDataFromQueryString () {
      let queryParams = this.$route.query
      if ( Object.keys(queryParams).length !== 0 ) {
        for (const [key, value] of Object.entries(queryParams)) {
          if ( Array.isArray(this[key]) == true ) {
            let explodedValue = value.split(',')
            for (let i = 0; i < explodedValue.length; i++) {
              this[key].push(explodedValue[i].trim())
            }
          } else {
            this[key] = value
          }
        }
      }

      // Exceptions to the rules
      // if this is a ministry news page (opo/en) or a type specific page (i.e. bulletins/en/), then reset these values. 
      // These filters are not exposed on these pages, and if not reset they will appear in the selected data object. they will also be sent to GA which is unnecessary
      if (this.$route.params.acronym) {
        this.ministries = []
      }
      if (this.$route.meta.type) {
        this.types = []
      }
    },
    // Build the SelectedDataObject. This gets passed back to the parent (Results) and used in the results count, and selected filters section on the page.
    // Within this component, this data is used for a Filter GA Event
    buildSelectedDataObject () {
      // Reset selected
      this.selected = []

      // Go through selected types
      //* ****************************************************************************
      for (const selected in this.types)
      {
        // Need to grab the specific selected type from original list
        for (const item in this.apiData.types)
        {
          // Get specific object - needs to work for search and news components
          if (this.apiData.types[item].id == this.types[selected] || this.apiData.types[item].value == this.types[selected])
          {
            // Create new array
            let filterObject = []
            filterObject["name"] = "type" // Set filter name
            filterObject["id"] = this.apiData.types[item].id // Set filter id
            filterObject["label"] = this.apiData.types[item].label // Set filter label
            filterObject["value"] = this.apiData.types[item].value // Set filter value
            // Add array to end of array
            this.selected.push(filterObject)
          }
        }
      }
      // Go through selected ministries
      //* ****************************************************************************
      for (const selected in this.ministries)
      {
        // Need to grab the specific selected type from original list
        for (const item in this.apiData.ministries)
        {
          // Get specific object
          // Name is what's sent to Elastic, name_aabreviated is what's displayed to the user
          if (this.$route.name == 'search') {
            if (this.apiData.ministries[item].name == this.ministries[selected])
            {
              // Create new array
              let filterObject = []
              filterObject["name"] = "ministry" // Set filter name
              filterObject["id"] = this.apiData.ministries[item].name // Set filter id
              filterObject["label"] = this.apiData.ministries[item].name_abbreviated // Set filter label
              filterObject["value"] = this.apiData.ministries[item].name // Set filter value
              // Add array to end of array
              this.selected.push(filterObject)
            }
          } else {
            if (this.apiData.ministries[item].id == this.ministries[selected])
            {
              // Create new array
              let filterObject = []
              filterObject["name"] = "ministry" // Set filter name
              filterObject["id"] = this.apiData.ministries[item].id // Set filter id
              filterObject["label"] = this.apiData.ministries[item].name_abbreviated // Set filter label
              filterObject["value"] = this.apiData.ministries[item].id // Set filter value
              // Add array to end of array
              this.selected.push(filterObject)
            }
          }
          
        }
      }
      // Go through selected topics
      //* ****************************************************************************
      for (const selected in this.topics)
      {
        // Need to grab the specific selected type from original list
        for (const item in this.apiData.topics)
        {
          // Get specific object - needs to work for search and news components
          if (this.apiData.topics[item].id == this.topics[selected] || this.apiData.topics[item].name == this.topics[selected]) {
            // Create new array
            let filterObject = []
            filterObject["name"] = "topic" // Set filter name
            filterObject["id"] = this.apiData.topics[item].id // Set filter id
            filterObject["label"] = this.apiData.topics[item].name // Set filter label
            filterObject["value"] = this.apiData.topics[item].id // Set filter value
            // Add array to end of array
            this.selected.push(filterObject)
          }
        }
      }
    },
    updateFilters () {
      if ( this.validateForm() ) {
        this.buildSelectedDataObject()
        // if this.selected is not null, start preping filter data to send ga
        if (this.selected) {
          this.prepGAFilterData(this.selected)
        }
        this.$emit('change-filters', this.selected, this.types, this.ministries, this.topics, this.start_date, this.end_date, this.sort)
      }
      var clear = document.getElementById('clear_filter_button')
      clear.style.display = 'inline'
    },
    // This function is triggered from the parent (results) when a user x's out of a filter.
    // The item is compared against the selected filter data (types, ministries, topics) and removed.
    // At the end, updateFilters() is run
    removeSelected (item, index) {
      switch (item.name) {
        case 'type': {
          for (let i = 0; i < this.types.length; i++) {
            // Find the value position within the array
            if (this.types[i] == item.value || this.types[i] == item.id) { // needs to be value for ES search
              // Remove object from array
              this.types.splice(i, 1)
              break
            }
          }
          break
        }
        case 'ministry': {
          for (let i = 0; i < this.ministries.length; i++) {
            // Find the value position within the array
            if (this.ministries[i] == item.id) {
              // Remove object from array
              this.ministries.splice(i, 1)
              break
            }
          }
          break
        }
        case 'topic': {
          for (let i = 0; i < this.topics.length; i++) {
            // Find the value position within the array
            if (this.topics[i] == item.label || this.topics[i] == item.id) { // needs to be label for ES search
              // Remove object from array
              this.topics.splice(i, 1)
              break
            }
          }
          break
        }
      }

      this.updateFilters()
    },
    clearFilters () {
      this.selected = []
      this.types = []
      this.ministries = []
      this.topics = []
      this.start_date = null
      this.end_date = null
      this.sort = 'desc'
      var clear = document.getElementById('clear_filter_button')
      clear.style.display = 'none'
      this.showFilterBar = false
      this.updateFilters()
    },
    validateForm () {
      this.errorMessages = []

      let successfulSubmit = true
      let startDate = this.start_date
      let endDate = this.end_date

      if (startDate != null && startDate != '') {
        let refDate = this.$refs.startDate
        if ( !this.validateDate(startDate) ) {
          successfulSubmit = false
          this.errorMessages.push('Dates should be valid and in the format of YYYY-MM-DD. You entered ' + startDate);
          refDate.className = "border border-danger"
        } else {
          refDate.className = refDate.className.replace('border', '')
          refDate.className = refDate.className.replace('border-danger', '')
        }
      }

      if (endDate != null && endDate != '') {
        let refDate = this.$refs.endDate
        if ( !this.validateDate(endDate) ) {
          successfulSubmit = false
          this.errorMessages.push('Dates should be valid and in the format of YYYY-MM-DD. You entered ' + endDate);
          refDate.className = "border border-danger"
        } else {
          refDate.className = refDate.className.replace('border', '')
          refDate.className = refDate.className.replace('border-danger', '')
        }
      }

      return successfulSubmit

    },
    validateDate: function (date) {
      var reg = /^\d{4}-\d{2}-\d{2}$/
      if ( reg.test(date) ) {
        let isISO = date + 'T00:00:00.000Z'
        if ( new Date(isISO) !== "Invalid Date" && !isNaN(new Date(isISO)) ) {
          return true
        } else {
          return false
        }
      } else {
        return false
      }
    },
    prepGAFilterData (selected) {
      // Clear the object of any old values and set variable type before rebuilding it
      this.clearGAFilterEventData()

      // Loop through the selected data variable. Wherever an entry name matches the entry type for a gaFilterEventData key, then push values into that index
      for (let i = 0; i < selected.length; i++) {
        let index = selected[i]['name']
        this.gaFilterEventData[index].push(selected[i].label)
      }

      // If the arrays have values, sort them. Else set object key's value to undefined
      // Undefined is needed for GA if value is empty
      if (this.gaFilterEventData['type'].length) {
        this.gaFilterEventData['type'].sort()
      } else {
        this.gaFilterEventData['type'] = undefined
      }

      if (this.gaFilterEventData['ministry'].length) {
        this.gaFilterEventData['ministry'].sort()
      } else {
        this.gaFilterEventData['ministry'] = undefined
      }

      if (this.gaFilterEventData['topic'].length) {
        this.gaFilterEventData['topic'].sort()
      } else {
        this.gaFilterEventData['topic'] = undefined
      }

      this.gaFilterEventData['publishStartDate'] = (this.start_date ? this.start_date : undefined)
      this.gaFilterEventData['publishEndDate'] = (this.end_date ? this.end_date : undefined)
      this.gaFilterEventData['sort'] = (this.sort ? this.sort : undefined)

      this.fireGAEvent()
    },
    // Reset the gaFilterEventdata with an empty instance of itself
    // Because GA expects empty values (even arrays) to be returned as undefined, this object needs to be reset in a structure we expect
    // Otherwise when trying to push to the arrays, errors will occur as they will be undefined rather than an empty array
    clearGAFilterEventData () {
      let gaFilterEventData = {
        type: [],
        ministry: [],
        topic: [],
        publishStartDate: null,
        publishEndDate: null,
        sort: null
      }
      this.gaFilterEventData = gaFilterEventData
    },
    fireGAEvent () {
      window.dataLayer.push({
        'event': 'apply filter',
        'newsType': this.gaFilterEventData['type'],
        'ministry': this.gaFilterEventData['ministry'],
        'topic': this.gaFilterEventData['topic'],
        'publishStartDate': this.gaFilterEventData['publishStartDate'],
        'publishEndDate': this.gaFilterEventData['publishEndDate'],
        'sort': this.gaFilterEventData['sort']
      })
    },
    // Mobile resize - hide and show filter section
    handleResize () {
      this.screenWidth = window.innerWidth
      if (this.screenWidth > 992) {
        this.apiData_expand = true
      }
    }
  },
  created () {
    this.fetchFilterData(this.apiEndPoints)
  },
  mounted () {
    this.setDataFromQueryString()
    window.addEventListener('resize', this.handleResize)
    this.handleResize()
  },
  destroyed () {
    window.removeEventListener('resize', this.handleResize)
  }
}
</script>
